import React, { FC, MouseEventHandler } from 'react';
import styled from 'styled-components';
import { Fansea3DStageMenuButtonV2 } from './Fansea3DStageMenuButtonV2';
import { Fansea3DStageTheme } from './Fansea3DStageTheme';

const StyledMenu = styled.div`
  padding: 8px;
  display: flex;
  justify-content: flex-end;
  position: absolute;
  width: 100%;
  bottom: 20px;
  right: 20px;
`;

export interface Fansea3DStageMenuProps {
  onToggleFullscreen: MouseEventHandler<HTMLButtonElement>;
  onToggleInspector: MouseEventHandler<HTMLButtonElement>;
  onResetCamera: MouseEventHandler<HTMLButtonElement>;
  theme?: Fansea3DStageTheme;
  isInspectorOpen?: boolean;
}

export const Fansea3DStageMenu: FC<Fansea3DStageMenuProps> = ({
  // onToggleFullscreen,
  onToggleInspector,
  // onResetCamera,
  isInspectorOpen = false,
  theme = Fansea3DStageTheme.Dark,
}) => {
  return (
    <StyledMenu>
      <Fansea3DStageMenuButtonV2
        isInspectorOpen={isInspectorOpen}
        onClick={onToggleInspector}
        theme={theme}
      />
    </StyledMenu>
  );
};
